<template>
  <div id="my_map"></div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState } from "vuex";

export default {
  name: "rotation-web-map",
  props: {},
  data() {
    return {
      centerZip: {},
      rotationColor: "",
      zipObjectsInTerritory: [],
      zipCodesAsArray: [],
      zipCodesAsString: "",
      rotationZipObjectsInTerritory: [],
      nonRotationZipObjectsInTerritory: [],
      rotationZipCodesAsArray: [],
      rotationZipCodesAsString: "",
      nonRotationZipCodesAsString: "",
    };
  },
  computed: {
    ...mapState(["territory"]),
  },
  watch: {
    "$store.state.territory.territory_edit.CenterZip": function (
      newValue,
      oldValue
    ) {
      if (newValue) {
        //this.loadMap(this);
      }
    },
    "$store.state.territory.rotation_edit.RotationColor": function (
      newValue,
      oldValue
    ) {
      if (newValue) {
        this.rotationColor = this.hexToRGBA(newValue, 1);
      }
    },
    "$store.state.territory.territory_edit.DefaultRadius": function (
      newValue,
      oldValue
    ) {
      this.refreshWait(newValue);
    },
    "$store.state.territory.rotation_edit.RotationID": function (
      newValue,
      oldValue
    ) {
      if (newValue) {
        this.loadMap(this);
      }
    },
  },
  methods: {
    refreshWait(newRadius) {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.loadMap(this);
      }, 2000);
    },
    saveField: function (_zip, _include) {
      var _operation = {
        RotationID: this.$store.state.territory.rotation_edit.RotationID,
        ZipCode: _zip,
        Include: _include,
      };
      this.$store.dispatch("zip/setRotationZipStatus", _operation).then();
    },
    hexToRGBA(hex, opacity) {
      return (
        "rgba(" +
        (hex = hex.replace("#", ""))
          .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
          .map(function (l) {
            return parseInt(hex.length % 2 ? l + l : l, 16);
          })
          .concat(opacity || 1)
          .join(",") +
        ")"
      );
    },
    async getCenter() {
      await this.$store
        .dispatch(
          "territory/GetZipCoordinates",
          this.$store.state.territory.territory_edit.CenterZip
        )
        .then((response) => {
          this.centerZip = response.data["GetCoordinatesResult"];
        });
    },
    async loadTerritoryZips() {
      await this.$store
        .dispatch(
          "territory/GetTerritoryZips",
          this.$store.state.territory.territory_edit
        )
        .then((response) => {
          this.zipObjectsInTerritory = response.data["ZipsInTerritoryResult"];
          this.zipCodesAsArray = this.zipObjectsInTerritory.map(
            (a) => a.ZipCode
          );
          this.zipCodesAsString = this.zipCodesAsArray.toString();
          
        });
    },
    async loadRotationZips_orig() {
      await this.$store
        .dispatch(
          "territory/GetRotationZips",
          this.$store.state.territory.rotation_edit
        )
        .then((response) => {
          this.rotationZipObjectsInTerritory =
            response.data["ZipsInRotationResult"];
          this.rotationZipCodesAsArray = this.rotationZipObjectsInTerritory.map(
            (a) => a.ZipCode
          );
          this.rotationZipCodesAsString = this.rotationZipCodesAsArray.toString();
        });
    },
    async loadRotationZips() {
      await this.$store
        .dispatch(
          "territory/GetRotationZipsByTerritory",
          this.$store.state.territory.territory_edit
        )
        .then((response) => {
          this.rotationZipObjectsInTerritory =
            response.data["ZipsInRotationByTerritoryResult"];
          this.rotationZipCodesAsArray = this.rotationZipObjectsInTerritory.filter(zip => zip.RotationID === this.$store.state.territory.rotation_edit.RotationID).map(
            (a) => a.ZipCode
          );
          this.nonRotationZipCodesAsArray = this.rotationZipObjectsInTerritory.filter(zip => zip.RotationID !== this.$store.state.territory.rotation_edit.RotationID).map(
            (a) => a.ZipCode
          );
          this.rotationZipCodesAsString = this.rotationZipCodesAsArray.toString();
          this.nonRotationZipCodesAsString = this.nonRotationZipCodesAsArray.toString();
         
        });
    },

    async loadRotationSymbols() {
    },
    
    async loadMap(_vue) {
      await this.loadTerritoryZips();
      await this.loadRotationZips();
      var _rotationID = _vue.$store.state.territory.rotation_edit.RotationID;
      await this.getCenter().then(() => {
        loadModules(
          [
            "esri/Map",
            "esri/views/MapView",
            "esri/layers/FeatureLayer",
            "esri/layers/GraphicsLayer",
            "esri/Graphic",
            "esri/Color",
          ],
          { css: true }
        ).then(
          ([
            ArcGISMap,
            MapView,
            FeatureLayer,
            GraphicsLayer,
            Graphic,
            Color,
          ]) => {
            const territorymap = new ArcGISMap({
              basemap: "topo",
            });

            var zipcodes = new FeatureLayer({
              url:
                "https://services.arcgis.com/P3ePLMYs2RVChkJx/ArcGIS/rest/services/USA_ZIP_Codes/FeatureServer/0",
            });

            var staticGraphicsLayer = new GraphicsLayer({id: "static"});
            territorymap.add(staticGraphicsLayer);

            var graphicsLayer = new GraphicsLayer({id: "active"});
            territorymap.add(graphicsLayer);

             var dynamicGraphicsLayer = new GraphicsLayer({id: "dynamic"});
            territorymap.add(dynamicGraphicsLayer);


            var mouseover_graphicsLayer = new GraphicsLayer({
              labelingInfo: [zipcodeLabels],
              id: "mouseover"
            });
            territorymap.add(mouseover_graphicsLayer);

            var view = new MapView({
              container: "my_map",
              map: territorymap,
              center: [this.centerZip.Longitude, this.centerZip.Latitude],
              zoom: 4,
            });

            var _whereClause = "ZIP = " + this.centerZip.ZipCode;

            var _whereClauseTerritoryZips =
              "ZIP in (" + this.zipCodesAsString + ")";

            var _whereRotationZips =
              "ZIP in (" + this.rotationZipCodesAsString + ")";
           var _whereNonRotationZips =
              "ZIP in (" + this.nonRotationZipCodesAsString + ")";


            view.when(function () {
              var centerZipQuery = {
                geometry: view.center,
                //distance:
                //  _vue.$store.state.territory.territory_edit.DefaultRadius,
                //units: "miles",
                //spatialRelationship: "intersects",
                outFields: ["ZIP"],
                returnGeometry: true,
                where: _whereClause,
              };
              zipcodes
                .queryFeatures(centerZipQuery)
                .then(function (result) {
                  addGraphics(result, true);
                  zoomToGraphics(result, true);
                })
                .then(function () {
                  var query = {
                    //geometry: view.center,
                    //distance:
                    //  _vue.$store.state.territory.territory_edit.DefaultRadius,
                    //units: "miles",
                    //spatialRelationship: "intersects",
                    outFields: ["ZIP"],
                    returnGeometry: true,
                    where: _whereClauseTerritoryZips,
                  };
                  zipcodes.queryFeatures(query).then(function (result) {
                    addGraphics(result, true);
                    //addRotationGraphics(result, true)
                  });
                })
                .then(function () {
                  var static_query = {
                    //geometry: view.center,
                    //distance:
                    //  _vue.$store.state.territory.territory_edit.DefaultRadius,
                    //units: "miles",
                    //spatialRelationship: "intersects",
                    outFields: ["ZIP"],
                    returnGeometry: true,
                    where: _whereNonRotationZips,
                  };
                  zipcodes.queryFeatures(static_query).then(function (result) {
                    addStaticGraphics(result, true);
                  });
                })
                .then(function () {
                  var static_query = {
                    //geometry: view.center,
                    //distance:
                    //  _vue.$store.state.territory.territory_edit.DefaultRadius,
                    //units: "miles",
                    //spatialRelationship: "intersects",
                    outFields: ["ZIP"],
                    returnGeometry: true,
                    where: _whereRotationZips,
                  };
                  zipcodes.queryFeatures(static_query).then(function (result) {
                    addActiveGraphics(result, true);
                  });
                })
                ;
            });

            function zoomToGraphics(result) {
              result.features.forEach(function (feature) {
                view.goTo(feature.geometry).then(function () {
                  view.scale = 24000;
                  view.zoom = 9;
                });
                graphicsLayer.removeAll();
                staticGraphicsLayer.removeAll();
              });
            }

            function queryFeatureLayer(
              point,
              distance,
              spatialRelationship,
              sqlExpression
            ) {
              var query = {
                geometry: point,
                distance: distance,
                units: "miles",
                spatialRelationship: spatialRelationship,
                outFields: ["ZIP"],
                returnGeometry: true,
                where: sqlExpression,
              };
              zipcodes.queryFeatures(query).then(function (result) {
                addGraphics(result, true);
              });
            }

            view.on("pointer-move", function (evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y,
              };

              view.hitTest(screenPoint).then(function (response) {
                getHoverGraphics(response);
              });
            });

            view.on("click", function (evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y,
              };

              view.hitTest(screenPoint).then(function (response) {
                getGraphics(response);
              });
            });

            function getGraphics(response) {
                var _handled = false;            
               if (response.results.length) {
                 response.results.forEach(function (_result) {
                   if (!_handled && (_result.graphic.layer.id === 'active' || _result.graphic.layer.id === 'dynamic'))
                   {
                     if (_result.graphic.symbol.color.toString() == _color)
                      {
                      _result.graphic.symbol = _nonTerritorySymbol;
                      _vue.saveField(_result.graphic.attributes.ZIP, false);
                      }
                      else
                      {
                      _result.graphic.symbol = _territorySymbol;
                      _vue.saveField(_result.graphic.attributes.ZIP, true);
                      }
                  _handled = true;
                   }
                });
              }
            }

            function getHoverGraphics(response) {
              if (response.results.length) {
                var graphic = response.results[0].graphic;
                addSingleGraphic(graphic);
              }
            }

            function addSingleGraphic(graphic) {
              mouseover_graphicsLayer.removeAll();
              // var g = new Graphic({
              //   geometry: graphic.geometry,
              //   attributes: graphic.attributes,
              //   symbol: {
              //     type: "simple-fill", // autocasts as new SimpleFillSymbol()
              //     color: [255, 128, 0, 0.7],
              //     outline: {
              //       // autocasts as new SimpleLineSymbol()
              //       width: 1,
              //       color: "black"
              //     }
              //   }
              // });

              var h = new Graphic({
                geometry: graphic.geometry,
                attributes: graphic.attributes,
                symbol: {
                  type: "text",
                  text: graphic.attributes["ZIP"],
                  font: {
                    size: 10,
                    weight: "bold",
                  },
                },
              });

              //mouseover_graphicsLayer.add(g);
              mouseover_graphicsLayer.add(h);
            }

            var zipcodeLabels = {
              symbol: {
                type: "text",
                color: "#000",
                font: {
                  size: "8px",
                  family: "Noto Sans",
                  style: "italic",
                  weight: "normal",
                },
              },
              labelPlacement: "center-center",
              labelExpressionInfo: {
                expression: "$feature.ZIP",
              },
            };

            var _color = new Color(this.rotationColor);
            var _default_color = new Color([255, 255, 255, 0]);
            var _territorySymbol = {
              type: "simple-fill",
              color: _color,
              outline: {
                width: 1,
                color: "black",
              },
            };

            var _nonTerritorySymbol = {
              type: "simple-fill",
              color: _default_color,
              outline: {
                width: 1,
                color: "black",
              },
            };

            function addGraphics(result) {

              result.features.forEach(function (feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _nonTerritorySymbol,
                });

                graphicsLayer.add(g);
              });
            }
          

function addRotationGraphics(result) {


              result.features.forEach(function (feature) {
                
                if (
                  _vue.$store.state.zip.rotation_zip_symbols.filter(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"]
                    && ele.TerritoryID === _vue.$store.state.territory.territory_edit.TerritoryID
                  ).length > 0
                ) {
                  

                  var _pColor = _vue.$store.state.zip.rotation_zip_symbols.find(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"]
                    && ele.TerritoryID === _vue.$store.state.territory.territory_edit.TerritoryID
                  ).SymbolColor;

                  var _localSymbol = {
                    type: "simple-fill",
                    color: _pColor,
                    outline: {
                      width: 1,
                      color: "black",
                    },
                  };
                  var g = new Graphic({
                    geometry: feature.geometry,
                    attributes: feature.attributes,
                    //symbol: _nonTerritorySymbol,
                    symbol: _localSymbol,
                  });

                  staticGraphicsLayer.add(g);
                }
                });

              
            }

            
            function addGraphicsEdited(result) {
              result.features.forEach(function (feature) {
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _nonTerritorySymbol,
                });

                graphicsLayer.add(g);
              });
            }

            function addStaticGraphics(result) {
              result.features.forEach(function (feature) {
                 var _localSymbol = {
                  type: "simple-fill",
                  color: _vue.rotationZipObjectsInTerritory.find(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"] && ele.RotationID !== _rotationID
                  ).Rotation.RotationColor,
                  outline: {
                    width: 1,
                    color: "black",
                  },
                };
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  //symbol: _territorySymbol,
                  symbol: _localSymbol,
                });

                staticGraphicsLayer.add(g);
              });
            }

            function addActiveGraphics(result) {
              result.features.forEach(function (feature) {
                 var _localSymbol = {
                  type: "simple-fill",
                  color: _vue.rotationZipObjectsInTerritory.find(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"] && ele.RotationID === _rotationID
                  ).Rotation.RotationColor,
                  outline: {
                    width: 1,
                    color: "black",
                  },
                };
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  //symbol: _territorySymbol,
                  symbol: _localSymbol,
                });
               dynamicGraphicsLayer.add(g);
                
              });
            }

            function addEditGraphics(result) {
              result.features.forEach(function (feature) {
                var _localSymbol = {
                  type: "simple-fill",
                  color: _vue.rotationZipObjectsInTerritory.find(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"]
                  ).Rotation.RotationColor,
                  outline: {
                    width: 1,
                    color: "black",
                  },
                };
                var g = new Graphic({
                  geometry: feature.geometry,
                  attributes: feature.attributes,
                  symbol: _localSymbol,
                });


                if (_vue.rotationZipObjectsInTerritory.find(
                    (ele) => ele.ZipCode === feature.attributes["ZIP"]
                  ).Rotation.RotationColor === _color.toHex().toUpperCase())
                {
                  graphicsLayer.add(g);
                }
                else
                {
                  staticGraphicsLayer.add(g);
                }
              });
            }
          }
        );
      });
    },
  },
  mounted() {
    if (this.$store.state.territory.rotation_edit.RotationID > 0) {
      this.rotationColor = this.hexToRGBA(
        this.$store.state.territory.rotation_edit.RotationColor,
        1
      );
      this.loadMap(this);
    }
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}
#my_map {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 600px;
  box-sizing: content-box;
  display: flex;
  line-height: normal;
}
</style>
